export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_rp8trade.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a RP8 Trade",
    text: [
      "A RP8 Trade nasceu para facilitar a vida do investidor. Com estratégias 100% automatizadas, algoritmos robustos e gestão de risco inteligente, buscamos ser referência em automação, performance e confiabilidade. Nosso foco é a inovação contínua para resultados consistentes.",
    ],
    testimonial: {
      text: "Confiabilidade, Transparência e Gestão de Risco são nossos pilares.",
      author: {
        name: "Rodolfo Paulino, sócio fundador e estrategista da RP8 Trade",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Alguns números da RP8 Trade",
    subtitle: "Venha conhecer nossas estratégias",
    data: [
      {
        value: "+10k",
        description: "Horas de Backtest",
      },
      {
        value: "+20",
        description: "Estratégias Validadas",
      },
      {
        value: "+5",
        description: "Anos de experiência no Mercado Financeiro",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da RP8 Trade?",
    subtitle: "Veja quais as principais vantagens dos robôs da RP8 Trade.",
    data: [
      {
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias para operações sem intervenção humana.",
      },
      {
        title: "Suporte individual",
        description: "Atendimento individual e humanizado para esclarecer todas as suas dúvidas.",
      },
      {
        title: "Validação Estatística",
        description: "Nossos robôs passam por diversos testes estatísticos antes de serem validados.",
      },
      {
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar horas na frente do computador acompanhando as operações. Basta escolher a estratégia e deixar que a plataforma opere por você.",
      },
      {
        title: "Sem emocional",
        description: "Estratégias automatizadas eliminam o fator emocional das operações.",
      },
      // {
      //   title: "15 dias para testar",
      //   description: "Teste nossas estratégias e confira a performance das nossas automações. ",
      // },
    ],
  },
  cta: {
    title: "Pronto para iniciar nessa jornada?",
    subtitle: "Escolha seu plano e ative já!",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A RP8 Trade",
    col1: [
      "Criei a RP8 Trade com o objetivo de desenvolver robôs de day trade com tecnologia de ponta, algoritmos robustos e gestão de risco inteligente, democratizando o acesso a estratégias de negociação automatizadas, seguras e de alto desempenho. Acredito que essa combinação é perfeita para traders e investidores que desejam diversificar sua carteira.",
      "Transparência e Ética: Agimos com clareza total sobre o desempenho, riscos e funcionamento de nossos produtos, mantendo a honestidade e a integridade como pilares de todas as nossas interações. ",
    ],
    col2: [
      "Performance e Consistência: Nosso foco principal é a entrega de resultados consistentes e a otimização contínua da performance, garantindo que o valor gerado para o cliente seja o centro de nosso desenvolvimento. ",
      "Gestão de Risco Responsável: Incorporamos a gestão de risco como um componente fundamental em todos os nossos robôs, promovendo uma cultura de negociação disciplinada e protegendo o capital de nossos clientes. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da RP8 Trade",
  },
  strategies: {
    title: "Estratégias RP8 Trade",
    heading: "Estratégias validadas e robustas ao seu alcance.",
    subtitle:
      "Estratégias desenvolvidas por quem vive o mercado financeiro. Comece agora mesmo com apenas alguns cliques.",
  },
};
